/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatListSources } from "../funcs/chatListSources.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSourcesResult } from "../models/components/listsourcesresult.js";
import {
  ListChatSourcesRequest,
  ListChatSourcesSecurity,
} from "../models/operations/listchatsources.js";
import { unwrapAsync } from "../types/fp.js";
export type ListChatSourcesQueryData = ListSourcesResult;

export function prefetchListChatSources(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListChatSourcesRequest | undefined,
  security?: ListChatSourcesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListChatSourcesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListChatSourcesQuery(
  client$: GramCore,
  request?: ListChatSourcesRequest | undefined,
  security?: ListChatSourcesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListChatSourcesQueryData>;
} {
  return {
    queryKey: queryKeyListChatSources({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
      gramChatSession: request?.gramChatSession,
    }),
    queryFn: async function listChatSourcesQueryFn(
      ctx,
    ): Promise<ListChatSourcesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(chatListSources(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListChatSources(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
    gramChatSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "chat", "listSources", parameters];
}
